export default __webpack_public_path__ + "static/media/tyler_wisniewski.b5a34550.jpg";